import { ReferenceMediaFile } from 'types'

const VIDEO_EXTENSIONS = new Set(['mp4', 'mpeg', 'webm', 'mov', 'avi', 'mkv', 'm4v'])

export const isVideoReferenceMedia = (media: ReferenceMediaFile): boolean => {
  if (media.duration != null) return true
  const path = (media.url ?? '').split('?')[0]
  const dot = path.lastIndexOf('.')
  return dot >= 0 && VIDEO_EXTENSIONS.has(path.slice(dot + 1).toLowerCase())
}
